import axios from 'axios';
import store from '@/store';
import S_scope from '@/service/api/v1/scope';
import S_SystemClass from '@/service/api/v1/system_class';
import S_ActType from '@/service/api/v1/act_type';
import S_LicenseType from '@/service/api/v1/license_type';
import S_EventType from '@/service/api/v1/event_type';
import S_PackageLanguage from '@/service/api/v1/package_language';
import S_ContractorType from '@/service/api/v1/contractor_type';
import S_ContractorCustomedType from '@/service/api/v1/contractor_customed_type';
import S_Effect from '@/service/api/v1/effect';
import S_TrainingType from '@/service/api/v1/training_type';
import S_Locale from '@/__vue2stone/service/api/v1/locale';
import H_common from '@/helpers/common';
import i18n from '@/i18n';

export default {
  async localeInit() {
    const res = await S_Locale.index({});
    store.dispatch('locale/setLocales', res);
  },
  async packageLanguageInit() {
    if (!store.state.app.factoryId) return;
    let currentUser = store.state.stone_auth.currentUser;
    if (!currentUser || !currentUser.locale) {
      store.dispatch('stone_locale/setSelectingLocale', { code: 'tw' });
    } else {
      store.dispatch('stone_locale/setSelectingLocale', currentUser.locale);
    }
    const code =
      currentUser && currentUser.locale ? currentUser.locale.code : 'tw';
    i18n.locale = code;
    store.dispatch('auth/setLocaleCode', code);
    axios.defaults.params = {lang: code};
    if (currentUser) {
      const localeId = currentUser.locale ? currentUser.locale.id : store.state.locale.locales[0].id;
      const res = await S_PackageLanguage.index({locale: localeId});
      store.dispatch('auth/loadPackageLanguage');
      i18n.mergeLocaleMessage(code, res);
    }
  },
  roleInit() {
    const currentFactoryId = store.state.app.factory.id;
    const {user_factory_roles, user_factory_role_templates} = store.state.stone_auth.currentUser;
    const roles = [];
    user_factory_role_templates.forEach(role => {
      if (role.factory_id === currentFactoryId) roles.push({
        ...role,
        isTemplate: true,
      });
    })
    user_factory_roles.forEach(role => {
      if (role.factory.id === currentFactoryId) roles.push({
        ...role,
        isTemplate: false,
      });
    })
    store.dispatch('auth/setRoles', roles);
  },
  scopeInit() {
    if (store.state.auth.scopes && store.state.auth.scopes.length) return;
    let factoryScopes = [];
    const {
      user_factory_roles,
      user_factory_scopes,
      user_factory_role_templates,
    } = store.state.stone_auth.currentUser;
    const factoryScopeMap = new Map();
    if (user_factory_roles && user_factory_roles.length) {
      user_factory_roles.forEach(userItem => {
        const factoryId = userItem.factory.id;
        if (factoryScopeMap.has(factoryId)) {
          const index = factoryScopeMap.get(factoryId);
          const existingScopes = factoryScopes[index].scopes;
          factoryScopes[index].scopes = [
            ...existingScopes,
            ...(userItem.scopes || []),
          ];
        } else {
          const newIndex = factoryScopes.length;
          factoryScopes.push({
            id: factoryId,
            scopes: userItem.scopes || [],
          });
          factoryScopeMap.set(factoryId, newIndex);
        }
      });
    }
    if (user_factory_scopes &&user_factory_scopes.length) {
      user_factory_scopes.forEach(userItem => {
        const factoryId = userItem.factory.id;
        if (factoryScopeMap.has(factoryId)) {
          const index = factoryScopeMap.get(factoryId);
          const existingScopes = factoryScopes[index].scopes;
          factoryScopes[index].scopes = [
            ...existingScopes,
            ...(userItem.scopes || []),
          ];
        } else {
          const newIndex = factoryScopes.length;
          factoryScopes.push({
            id: factoryId,
            scopes: userItem.scopes || [],
          });
          factoryScopeMap.set(factoryId, newIndex);
        }
      });
    }
    if (user_factory_role_templates && user_factory_role_templates.length) {
      user_factory_role_templates.forEach(userItem => {
        const factoryId = userItem.factory_id;
        if (factoryScopeMap.has(factoryId)) {
          const index = factoryScopeMap.get(factoryId);
          const existingScopes = factoryScopes[index].scopes;
          factoryScopes[index].scopes = [
            ...existingScopes,
            ...(userItem.scopes || []),
          ];
        } else {
          const newIndex = factoryScopes.length;
          factoryScopes.push({
            id: factoryId,
            scopes: userItem.scopes || [],
          });
          factoryScopeMap.set(factoryId, newIndex);
        }
      });
    }
    factoryScopes = factoryScopes.filter(facItem => facItem.scopes.length > 0);
    factoryScopes.forEach((facItem, facIndex) => {
      factoryScopes[facIndex].scopes = facItem.scopes.filter((
        filterItem,
        filterIndex,
        arr
      ) => arr.indexOf(filterItem) === filterIndex);
    });
    store.dispatch('auth/setScopes', {
      factory: factoryScopes,
    });
  },
  async systemClassInit(params) {
    const res = await S_SystemClass.index({
      params: {
        ...params,
        order_by: 'sequence',
        order_way: 'asc',
      },
    });
    store.dispatch('model/setSystemClasses', res);
    this.userHasScopeSubClassesInit(res);
    return res;
  },
  async actTypeInit(params = {}) {
    const res = await S_ActType.index({
      params: {
        ...params,
        order_by: 'sequence',
        order_way: 'asc',
      },
    });
    store.dispatch('model/setActTypes', res.data);
  },
  async licenseTypeInit() {
    if (
      !H_common.hasSubscription('licenses') ||
      !S_scope.$_isAvailable(['license-read'])
    ) return;
    const res = await S_LicenseType.index({
      params: { order_by: 'sequence', order_way: 'asc' },
    });
    store.dispatch('model/setLicenseTypes', res.data);
  },
  async eventTypeInit() {
    if (
      !H_common.hasSubscription('events') ||
      !S_scope.$_isAvailable(['event-read'])
    ) return;
    const res = await S_EventType.index({
      order_by: 'sequence',
      order_way: 'asc',
    });
    store.dispatch('model/setEventTypes', res);
  },
  async contractorTypeInit() {
    if (
      !H_common.hasSubscription('contractors') ||
      !S_scope.$_isAvailable(['contractor-read'])
    ) return;
    const res = await S_ContractorType.index({
      params: {
        order_by: 'sequence',
        order_way: 'asc',
        get_all: 1,
      },
    });
    store.dispatch('model/setContractorTypes', res.data);
  },
  async contractorCustomedTypeInit() {
    if (
      !H_common.hasSubscription('contractors') ||
      !S_scope.$_isAvailable(['contractor-read'])
    ) return;
    const res = await S_ContractorCustomedType.index({
      params: {
        order_by: 'sequence',
        order_way: 'asc',
        get_all: 1,
      },
    });
    store.dispatch('model/setContractorCostomedTypes', res.data);
  },
  async effectInit() {
    const currentFactory = store.state.app.factory;
    const res = await S_Effect.index({
      order_by: 'sequence',
      order_way: 'asc',
      get_all: 1,
      area: currentFactory.area_id,
    });
    store.dispatch('model/setEffects', res);
  },
  async trainingTypeInit() {
    if (
      !H_common.hasSubscription('trainings') ||
      !S_scope.$_isAvailable(['internal-training-read'])
    ) return;
    const res = await S_TrainingType.index({
      params: {
        order_by: 'sequence',
        order_way: 'asc',
      },
    });
    store.dispatch('model/setTrainingTypes', res.data);
  },
  async userHasScopeSubClassesInit(allSystemClassesWithi18n) {
    const factoryId = store?.state?.app?.factory?.id;
    if (!factoryId) return;

    const list = store?.state?.stone_auth?.currentUser?.user_factory_system_subclasses;
    const factoryScopes = list?.find(item => item.factory?.id === factoryId);
    if (!factoryScopes) return;

    const source = allSystemClassesWithi18n || [];
    const allClassesList = new Map(source.map(item => [item.id, item]));
    const allSubclassesList = new Map(
      source.flatMap(item => (item.system_subclasses || []).map(sub => [sub.id, sub])),
    );

    const { system_classes = [], system_subclasses = [] } = factoryScopes;
    const scopeClasses = system_classes.map(c => allClassesList.get(c.id)).filter(Boolean);
    const scopeSubclasses = system_subclasses.map(s => allSubclassesList.get(s.id)).filter(Boolean);

    store.dispatch('auth/setSystemClasses', scopeClasses);
    store.dispatch('auth/setSystemSubclasses', scopeSubclasses);
  },
};
